import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const httpStore = new Vuex.Store({
  state: {
    host: 'https://dgearth.ru/', // изменится в main.js при инициализации проекта в зависимости от модуля(eco/quarry/construction ...)
    orders: 'api/v1/orders?with_analytics=1',
    profile: 'lk/api/profile',
    products: 'api/v1/products'
  },

  mutations: {
    setValue (state, keyValue) {
      state[keyValue.key] = keyValue.value
    }
  },

  actions: {
    setValue ({commit}, keyValue) {
      commit('setValue', keyValue)
    }
  },

  getters: {
    host: state => {
      return state.host
    },
    media: state => {
      return state.media
    },

    value: state => key => {
      if (key in state) {
        return state[key]
      } else {
        return null
      }
    },

    pdfReports: state => orderId => {
      return 'api/v1/orders/' + orderId + '/reports'
    },

    orderById: state => orderId => {
      return 'api/v1/orders/' + orderId + '/reports/default'
    },

    downloadLink: state => item => {
      return 'api/v1/orders/' + item.order_id + '/reports/' + item.report_id
    }
  }
})

export default httpStore



// WEBPACK FOOTER //
// ./src/storages/httpStore.js